import { cn } from "@/lib/utils";

export interface IconProps extends React.ComponentProps<"span"> {
  /** Nombre del glifo en Material Symbols Rounded, ej. `folder_open`. */
  name: string;
  /**
   * Tamaño en px. El DS usa 13 / 14 / 15 / 16 / 17 / 18 / 19 / 26 / 30 según
   * el contenedor: 15–17 dentro de un botón, 14–16 en una celda, 26 en un
   * estado vacío.
   */
  size?: number;
  /** Rellena el glifo (FILL 1). Reservado para el estado activo. */
  filled?: boolean;
}

/**
 * Ícono del Design System — Material Symbols Rounded (opsz 20, wght 300).
 *
 * Se renderiza como texto con ligadura, no como SVG: el nombre del glifo va
 * como hijo. Nunca uses emojis en la interfaz.
 *
 *     <Icon name="filter_alt" size={18} className="text-primary-hover" />
 */
export function Icon({
  name,
  size = 18,
  filled = false,
  className,
  style,
  ...props
}: IconProps) {
  return (
    <span
      aria-hidden="true"
      className={cn("material-symbols-rounded shrink-0 leading-none", className)}
      style={{
        fontSize: size,
        width: size,
        height: size,
        ...(filled
          ? { fontVariationSettings: '"FILL" 1, "wght" 300, "GRAD" 0, "opsz" 20' }
          : null),
        ...style,
      }}
      {...props}
    >
      {name}
    </span>
  );
}
